import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Unit } from '@app/models/profile.model';
import { KirokuMenu, MENU_KIDS, NameLocalStorage } from '@app/models/record.model';
import { StorageEnum } from '@app/shared/enum/storage';
import { Logout, SelectUnit } from '@app/store/auth/auth.classes';
import { AuthSelectors } from '@app/store/auth/auth.selectors';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-unit-select',
  templateUrl: './unit-select.component.html',
  styleUrls: ['./unit-select.component.scss'],
})
export class UnitSelectComponent implements OnInit {
  @Select(AuthSelectors.unitList) unitList$!: Observable<Unit[]>;
  private selectedUnit: Unit | null;
  private onDestroy$!: Subject<void>;

  constructor(
    private store: Store,
    private router: Router,
  ) {
    this.onDestroy$ = new Subject();
    this.selectedUnit = null;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  ngOnInit(): void {
  }

  selectUnit(unit: Unit): void {
    localStorage.removeItem(NameLocalStorage.DISPLAY_SETTING_DATE);
    localStorage.removeItem(NameLocalStorage.CONDITION_FILTER);
    this.store.dispatch(new SelectUnit(unit)).subscribe(() => {
      this.toKirokuList(KirokuMenu.KYOUNOKIROKU);
    });
  }

  onClose(): void {
    if (!this.selectedUnit) {
      this.store.dispatch(new Logout());
    } else {
      this.router.navigate(['', { outlets: { modal: null } }]);
    }
  }

  toList(updateFn: Function) {
    this.router.navigate(['home/list'], { replaceUrl: true, queryParamsHandling: "preserve" }).then(() => {
      updateFn();
      this.router.navigate([{ outlets: { modal: null, edit: null } }], { replaceUrl: true, queryParamsHandling: "preserve" })
    });
  }

  toKirokuList(configType: KirokuMenu) {
    const storage = () => {
      localStorage.setItem(StorageEnum.MENU, MENU_KIDS.KIROKU);
      localStorage.setItem(StorageEnum.MENU_ITEM, configType);
      window.dispatchEvent(new CustomEvent("menu-change", { detail: { key: 'change' } }));
    }
    this.toList(storage);
  }
}
